import React, { Component } from 'react'

import { Card, Button, Table, Modal, Select, Input, Tag, Tooltip } from 'antd'

import { connect } from 'react-redux'
import { req_page_ams_alumni, req_downloadfile_ams_alumni } from '../../api'
//import { formateDate } from '../../utils/dateUtil'
import { API_BASE, PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { usrRole } from '../../utils/dataUtil'

import AdumniSingleModal from './alumni-single-modal'
import AdumniEditModal from './alumni-edit-modal'

class AlumniManage extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        deviceWidth: 0,
        loading: false,
        userLevel: 'NORMAL',
        items: [],
        item: {},
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'None',
        searchValue: '',
        filterStatus: '',
        domnloadFile: '',
        isShowModal: false,
        isEditModal: false
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this))
        this.resize();
        this.api_page_items(1)
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this.resize.bind(this))
    }


    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode, role } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })
        this.setState({ loading: true })
        const result = await req_page_ams_alumni(userCode, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_downloadfile_items = async () => {
        const { userLevel, searchField, searchValue, filterStatus } = this.state
        const { token, userCode } = this.props.user

        // download file data
        const fileUrl = await req_downloadfile_ams_alumni(userCode, userLevel, searchField, searchValue, filterStatus, token)

        // download file link      
        let a = document.createElement('a');
        a.href = API_BASE + fileUrl;
        a.target = '_blank'
        a.download = '校友清單';
        a.click();
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '姓名',
                dataIndex: 'AlumniName',
                width: 30,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '性別',
                dataIndex: 'Sex',
                width: 20,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div className='text-center'>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '生日',
                dataIndex: 'Birthday',
                width: 40,
                responsive: ['md'],
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '電話',
                dataIndex: 'MobilePrincipal',
                width: 40,
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '電郵',
                dataIndex: 'EmailPrincipal',
                width: 80,
                responsive: ['md'],
            },
            {
                title: '調查狀態',
                dataIndex: '',
                width: 40,
                responsive: ['md'],
                filters: [
                    { text: '就業', value: '就業' },
                    { text: '升學', value: '升學' },
                    { text: '留學', value: '留學' },
                    { text: '服役', value: '服役' },
                    { text: '其他', value: '其他' },
                ],
                filterMultiple: false,
                render: (item) => {
                    const { NowStatusPrimary, NowStatusSecondary, Uid } = item
                    let color = this.style_switch_color_tag('NowStatusPrimary', NowStatusPrimary)
                    return (
                        <>
                            <Tag color={color} key={Uid}>
                                {NowStatusPrimary} / {NowStatusSecondary}
                            </Tag>
                        </>
                    )
                }
            },
            {
                title: '操作項目',
                dataIndex: '',
                width: 40,
                render: (item) => {
                    return (
                        <>
                            <Button type='dashed' size='small'  onClick={() => this.handle_show_ui_modal('view', item)}><i className="fas fa-user-alt"></i> <span style={{ marginLeft: '4px' }}>明細</span></Button>
                            <Button type='dashed' size='small'  onClick={() => this.handle_show_ui_modal('edit', item)}><i className="fas fa-user-edit"></i> <span style={{ marginLeft: '4px' }}>修改</span></Button>
                        </>
                    )
                },

            },
        ]
    }

    style_switch_color_tag(column, param) {
        if (column === 'NowStatusPrimary') {
            switch (param) {
                case '就業':
                case '服役':
                case '升學':
                case '留學':
                    return 'green'
                case '其他':
                    return 'purple'
                default:
                    return 'default';
            }
        }
        if (column === 'NowStatusSecondary') {
            switch (param) {
                case '尚待確認':
                    return 'red'
                case '就業':
                case '服役':
                case '升學':
                case '留學':
                    return 'green'
                case '其他':
                    return 'purple'
                default:
                    return 'default';
            }
        }
        if (column === 'ConfirmStatus') {
            switch (param) {
                case 'NO':
                    return 'red'
                case 'YES':
                    return 'green'
                default:
                    return 'default';
            }
        }
    }
    // 操作互動處理 //////////////////////////////////////////////

    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_download = () => {
        this.api_downloadfile_items()
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    handle_show_ui_modal = (modal, item) => {
        switch (modal) {
            case 'view':
                this.setState({ isShowModal: true, item })
                break;
            case 'edit':
                this.setState({ isEditModal: true, item })
                break;
            default:
        }
    }
    /////////////////////////////////////////////////////////////     

    render() {
        const { deviceWidth, loading, item, items, pagination, searchField, searchValue, isEditModal, isShowModal } = this.state
        const title = (
            <span>
                <Select value={searchField} style={{ width: 120 }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='None'>搜索條件</Select.Option>
                    <Select.Option value='TwId'>身分證字號</Select.Option>
                    <Select.Option value='AlumniName'>姓名</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 150, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i> 查詢</Button>
                {' '}
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                {' '}
                {deviceWidth > 600 ? (<><Button type='primary' onClick={() => this.handle_data_download()}><i className="fas fa-cloud-download-alt element-hidden"></i> 下載</Button></>) : ''}
            </span>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Uid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    title="查詢基本資料"
                    visible={isShowModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isShowModal: false })
                    }}
                    onCancel={() => {
                        this.setState({ isShowModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <AdumniSingleModal alumni={item} />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title="修改基本資料"
                    visible={isEditModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isEditModal: false })
                    }}
                    onCancel={() => {
                        this.setState({ isEditModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <AdumniEditModal alumni={item} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(AlumniManage)